import React from "react";
import { graphql } from "gatsby";
import { TwoColumn as TwoColumnComponent } from "@zempler/theme/src/components/twoColumn/TwoColumn";
import { NestedComponentRenderer } from "../../NestedComponentRenderer";

export const TwoColumn = ({ data, ...rest }) => {

  const columnOneComponents = data.areas[0].blockGridItems?.map((item) => {
    const { component } = item;
    return {
      ...component,
    };
  });

  const columnTwoComponents =  data.areas[1].blockGridItems?.map((item) => {
    const { component } = item;
    return {
      ...component,
    };
  });

  const columnOneHasImage =
    columnOneComponents?.some(
      (obj) => obj?.remoteTypeName === "SquareImageComponentType"
    ) && columnOneComponents?.length === 1;
  const columnTwoHasImage =
    columnTwoComponents?.some(
      (obj) => obj?.remoteTypeName === "SquareImageComponentType"
    ) && columnTwoComponents?.length === 1;


  return (
    <>
    <TwoColumnComponent
      centered={data.alignment === "Centred"}
      border={data.border}
      columnBackground={data.columnBackground}
      columnOneHasImage={columnOneHasImage}
      columnTwoHasImage={columnTwoHasImage}
      columnOneComponents={
        <NestedComponentRenderer components={columnOneComponents} />
      }
      columnTwoComponents={
        <NestedComponentRenderer components={columnTwoComponents} />
      }
      {...rest}
    />
    </>
  );
};

export const TwoColumnQuery = graphql`
  fragment TwoColumn on UMBRACO_TwoColumnComponentType {
    alignment
    border
    columnBackground
  }
`;
